// extracted by mini-css-extract-plugin
module.exports = {"banner__social__icons":"SocialIcons_banner__social__icons__2lhcl"};